import { useQuery } from "@tanstack/react-query";
import { useState } from "react";
import { clientAPI } from "../api/client";
import { NumberOfPerPage } from "../utils/globalVariable";
import { formatNumber } from "../utils/utils";

const NUMBER_NFT_PER_PAGE = NumberOfPerPage.serviceFee;
const queryKey = "serviceFee";

async function fetchServiceFee(currentPage, search, month, year) {
  try {
    const options = {
      limit: NUMBER_NFT_PER_PAGE,
      page: currentPage,
    };

    if (search !== undefined) options.search = search;
    if (month) options.month = month;
    if (year) options.year = year;
    
    const queryParams = new URLSearchParams(options).toString();
    let data = await clientAPI("get", `/commission/listByMonth?${queryParams}`);
    const totalServiceFee = data?.totalServiceFee
      ? `${formatNumber(Number(data?.totalServiceFee))} VNĐ`
      : "0 VNĐ";

    const totalPages = Math.ceil(data?.pagination?.total / NUMBER_NFT_PER_PAGE);
    const entries = data?.pagination?.total;
    const startEntry =
      (data?.pagination?.page - 1) * data?.pagination?.limit + 1;
    const endEntry = Math.min(
      data?.pagination?.page * data?.pagination?.limit,
      entries
    );

    const newData = data?.items.map((item, index) => {
      const month = item?._id?.month
        ? Number(item?._id?.month) < 10
          ? `0${item?._id?.month}`
          : item?._id?.month
        : "";
      const time =
        item?._id?.month && item?._id?.year
          ? `Tháng ${month}/${item?._id?.year}`
          : "-";

      return {
        time: time,
        code: item?.employee?.code || "-",
        fullName: item?.employee?.fullName || "-",
        jobTitle: item?.jobTitle?.name || "-",
        phone: item?.employee?.phone || "-",
        saleBlock: item?.saleBlock?.name || "-",
        saleArea: item?.saleArea?.name || "-",
        serviceFee: item?.serviceFee
          ? `${formatNumber(Number(item?.serviceFee))} VNĐ`
          : "0 VNĐ",
        detail: {
          time: time,
          code: item?.employee?.code || "-",
          fullName: item?.employee?.fullName || "-",
          item: item?.items || null,
          serviceFee: item?.serviceFee
            ? `${formatNumber(Number(item?.serviceFee))} VNĐ`
            : "0 VNĐ",
        },
      };
    });

    return {
      data: newData,
      totalServiceFee,
      totalPages,
      entries,
      startEntry,
      endEntry,
    };
  } catch (error) {
    console.error("Error fetching checkIn data:", error);
    return { data: [], totalPages: 0 };
  }
}

export function useServiceFee(search, month, year) { 
  const [currentPage, setCurrentPage] = useState(1);

  const { data, refetch, isLoading, isRefetching } = useQuery({
    queryKey: [queryKey, currentPage, search, month, year],
    queryFn: () => fetchServiceFee(currentPage, search, month, year),
    refetchOnWindowFocus: false,
    staleTime: 30000,
    keepPreviousData: true,
    onError: (error) => {
      console.error("Error fetching ServiceFee data:", error);
    },
  });

  const nextPage = () => {
    if (currentPage < data?.totalPages) {
      setCurrentPage(currentPage + 1);
    }
  };

  const prevPage = () => {
    if (currentPage > 1) {
      setCurrentPage(currentPage - 1);
    }
  };

  return {
    serviceFeeData: data?.data,
    totalServiceFee: data?.totalServiceFee,
    totalPages: data?.totalPages,
    refetch,
    isLoading,
    isRefetching,
    prevPage,
    nextPage,
    setCurrentPage,
    currentPage,
    entries: data?.entries,
    startEntry: data?.startEntry,
    endEntry: data?.endEntry,
  };
}
